import { type ColumnsType } from 'antd/es/table';
import dayjs from 'dayjs';

export type THistoryData = {
  comment: string;
  date: Date | string;
  text: string;
  status: {
    text: string;
    code: string;
  };
};

export const historyTableData: ColumnsType<THistoryData> = [
  {
    title: 'Комментарий',
    dataIndex: 'comment',
    key: 'comment',
    width: 250,
    sorter: (a, b) => a.comment.localeCompare(b.comment),
    render: (_, record) => record.comment
  },
  {
    title: 'Дата',
    dataIndex: 'date',
    key: 'date',
    width: 230,
    sorter: (a, b) => dayjs(a.date).valueOf() - dayjs(b.date).valueOf(),
    render: (_, record) => {
      return (
        <>
          {dayjs(record.date).format('DD.MM.YYYY, HH:mm')}
          <p className="history-modal__date-text">{record.text}</p>
        </>
      );
    }
  },
  {
    title: 'Статус',
    dataIndex: 'status',
    key: 'status',
    width: 200,
    sorter: (a, b) => a.status.code.localeCompare(b.status.code),
    render: (_, record) => {
      return (
        <span className="history-modal__status">{record.status.text}</span>
      );
    }
  }
];
